import kocLogo from '../../assets/koc-logo-footer.png';
import kocAilemlogo from '../../assets/images/koc-ailem-logo.png';
import infoIcon1 from '../../assets/images/join-form/appway1.png';
import infoIcon2 from '../../assets/images/join-form/appway2.png';
import infoIcon3 from '../../assets/images/join-form/appway3.png';

import Grid from '@mui/material/Grid';
import { CheckCircleOutlineRounded } from '@mui/icons-material';

import classes from './styles.module.scss';

const CongratPage = () => {

    return (
        <div className={classes.congratsPage}>
            <div className={classes.overlay}>
                <div className={classes.container}>
                    <Grid container spacing={0} direction="column" height="100%" wrap='nowrap'>
                        <Grid item flexGrow={1}>
                            <div className={classes.resultSection}>
                                <img src={kocAilemlogo} alt='KoçAilem Logo' />
                                <CheckCircleOutlineRounded className={classes.checkIcon} />
                                <h3>Tebrikler!</h3>
                                <h4>KoçAilem üyeliğin başarıyla tamamlandı!</h4>
                                <p>Sahip olduğun ayrıcalıkları hemen keşfetmek için aşağıdaki butonu tıklayarak yeni şifre oluşturman ve www.kocailem.com'a giriş yapman yeterli.</p>
                                <a href="https://www.kocailem.com/" className={classes.buttonLink} target="_blank" rel="noreferrer">Ayrıcalıklardan Yararlanmaya Başla</a>
                            </div>
                        </Grid>
                        <Grid item>
                            <div className={classes.infoSection}>
                                <div className={classes.top}>
                                    <h4 className={classes.head}>KoçAilem kredi kartı ve TLcard sahibi olabilmen için Yapı Kredi Bankası Çağrı Merkezi 444 0 444 seni en kısa sürede arayacak. Dilersen aşağıdaki 3 alternatif yoldan birini seçerek de kart başvurunu yapabilirsin.</h4>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={4}>
                                            <img src={infoIcon1} alt="" className='mx-0' />
                                            <p className='py-1'>Yapı Kredi İnternet Şubesi veya Mobil Şube'den</p>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <img src={infoIcon2} alt="" className='mx-0' />
                                            <p className='py-1'>KoçAilem boşluk TCKN yazıp 4944'e SMS göndererek</p>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <img src={infoIcon3} alt="" className='mx-0' />
                                            <p className='py-1'>En yakın Yapı Kredi Şubesi'nden</p>
                                        </Grid>
                                    </Grid>
                                </div>
                                <p className={classes.foot}>Tüm soruların için 444 0 447 KoçAilem Çağrı Merkezi'nden 7/24 destek alabilirsin.</p>
                            </div>
                        </Grid>
                        <Grid item>
                            <div className={classes.footer}>
                                <img src={kocLogo} alt='KoçAilem Logo' />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )
}

export default CongratPage